import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions } from 'actionsets'
import { SnackbarActions } from 'actionsets'
import StyleSheet from 'styles'
import {eventKeyMatches, humanize, KEYS} from 'utils'
import { CenteredCard } from 'components'
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography'
import qs from 'qs'

export class Confirm extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    SnackbarActions.bindActions(this)
  }

  componentDidMount = () => {
    this.submit()
  }

  get token(){
    return qs.parse(window.location.search.substr(1)).token
  }

  submit = async () => {
    await this.actions.confirm({token: this.token})
    await this.actions.verify()
    this.actions.show("Your account has been confirmed")
    this.props.history.push('/')

  }

  renderError = () =>
    <Typography variant='subtitle1' className={styles.error}>
      {this.props.error.map(({title}) => title).join(', ')}
    </Typography>

  renderErrorMessages = () => Object.entries(this.props.error[0].meta || {}).map(([key, value]) =>
    <Typography  key={key} variant='body2' className={styles.error}>
      <span>{`${humanize(key)}: ${[...new Set(value)]}`}</span>
    </Typography>
  )

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent onKeyUp={e => eventKeyMatches(e, KEYS.enter) && this.submit()}>
        {this.props.error && <p className={styles.error}>{this.renderError()}</p>}
        {this.props.error && this.renderErrorMessages()}
        <Typography variant='h5'>Confirming your account...</Typography>
      </CardContent>
    </CenteredCard>

}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  container: {
    position: 'fixed',
    top: 35,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
})

export default connect(({tokens}) => tokens)(Confirm)